import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DivisionMstApi } from '../api/division-mst.api';
import { DivisionMst, DivisionMstData } from '../../../interfaces/masters/division-mst';

@Injectable()
export class DivisionMstService extends DivisionMstData {

  constructor(private api: DivisionMstApi) {
    super();
  }

  list(url: string): Observable<any> {
    return this.api.list(url);
  }

  getById(url: string): Observable<DivisionMst> {
    return this.api.getById(url);
  }

  create(url: string, data: DivisionMst): Observable<any> {
    return this.api.add(url, data);
  }

  update(url: string, data: DivisionMst): Observable<any> {
    return this.api.update(url, data);
  }

}
